<template>
  <div class="reportList" v-loading="isloading">
    <el-row class="reportList-nav" id="reportListnav">
      <el-col>
        <el-form
          :inline="true"
          ref="search"
          size="mini"
          class="demo-form-inline"
        >
          <el-row>
            <el-col :span="22">
              <el-form-item label="时间选择" style="padding: 10px 10px 0 10px">
                <el-radio-group v-model="timeType">
                  <el-radio-button label="1">七天</el-radio-button>
                  <el-radio-button label="2">一个月</el-radio-button>
                  <el-radio-button label="3">一年</el-radio-button>
                  <el-radio-button label="4" class="nav-time">
                    <el-date-picker
                      v-model="DateArray"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :default-time="['00:00:00', '23:59:59']"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="changeTime"
                    ></el-date-picker>
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <div>
          <el-row>
            <el-col :span="20">
              <h4 style="margin-top: 0px">本科室检查报告阳性率统计</h4>
            </el-col>
            <el-col :span="4">
              <el-button
                @click="excel"
                size="mini"
                style="width: 100%"
                type="primary"
                >导出Excel</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="reportList-table">
          <el-table
            stripe
            :data="selfDepartPositiveRate"
            size="mini"
            style="width: 100%"
          >
            <el-table-column
              prop="date"
              label="日期"
              min-width="100px"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="modality" label="模态" min-width="60">
            </el-table-column>
            <el-table-column
              prop="positiveCount"
              label="阳性数量"
              min-width="80"
            >
            </el-table-column>
            <el-table-column prop="totalCount" label="总数量" min-width="80">
            </el-table-column>
            <el-table-column
              prop="positiveRate"
              label="阳性率(%)"
              min-width="80"
            >
            </el-table-column>
          </el-table>
          <div class="reportList-total">
            <div style="min-width: 25%">总数</div>
            <div style="min-width: 15%">--</div>
            <div style="min-width: 20%">
              {{ selfDeaprtPoaitiveRatePI.positiveSum }}
            </div>
            <div style="min-width: 20%">
              {{ selfDeaprtPoaitiveRatePI.countSum }}
            </div>
            <div style="min-width: 20%">
              {{ selfDeaprtPoaitiveRatePI.positiveRateSum }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { formatDate } from "@/utils/index.js";
import { mapGetters } from "vuex";
export default {
  name: "statistics",
  data() {
    return {
      DateArray: [
        formatDate(new Date(new Date() - 3600 * 1000 * 24 * 30), "yyyy-MM-dd"),
        formatDate(new Date(), "yyyy-MM-dd"),
      ],
      timeType: "2",
      isloading: false,
    };
  },
  computed: {
    ...mapGetters([
      "selfDepartPositiveRate",
      "selfDeaprtPoaitiveRatePI",
      "currentUserRoleDepart",
    ]),
  },
  mounted() {
    this.GetSelfDepartPositiveRate();
  },
  methods: {
    checkTimeType(type) {
      if (type === "1") {
        this.DateArray = [
          formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), "yyyy-MM-dd"),
          formatDate(new Date(), "yyyy-MM-dd"),
        ];
      }
      if (type === "2") {
        this.DateArray = [
          formatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 30),
            "yyyy-MM-dd"
          ),
          formatDate(new Date(), "yyyy-MM-dd"),
        ];
      }
      if (type === "3") {
        this.DateArray = [
          formatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 365),
            "yyyy-MM-dd"
          ),
          formatDate(new Date(), "yyyy-MM-dd"),
        ];
      }
      if (type === "4") {
        this.DateArray = this.DateArray;
      }
    },
    changeTime: function () {
      this.timeType = 4;
    },
    excel() {
      var days =
        new Date(this.DateArray[1]).getTime() -
        new Date(this.DateArray[0]).getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      if (time > 365) {
        this.$message({
          message: "您所选的时间段大于一年，不能导出Excel，请重新选择！",
          type: "warning",
        });
      } else {
        var date = new Date(this.DateArray[0]);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate();
        var startDate = Y + M + D;
        var date1 = new Date(this.DateArray[1]);
        var Y1 = date1.getFullYear() + "-";
        var M1 =
          (date1.getMonth() + 1 < 10
            ? "0" + (date1.getMonth() + 1)
            : date1.getMonth() + 1) + "-";
        var D1 = date1.getDate();
        var endDate = Y1 + M1 + D1;
        window.open(
          this.$getCfg("VUE_APP_BASE_API") +
            "/Statistics/GetSelfDepartPositiveRateSheet?departId=" +
            this.currentUserRoleDepart.departId +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            "&fileName=",
          "_blank"
        );
      }
    },
    GetSelfDepartPositiveRate() {
      this.isloading = true;
      this.$store
        .dispatch("GetSelfDepartPositiveRate", {
          startDate: this.DateArray[0],
          endDate: this.DateArray[1],
        })
        .then(() => {
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
  watch: {
    timeType(type) {
      this.checkTimeType(type);
    },
    DateArray(datas) {
      this.GetSelfDepartPositiveRate();
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
$background-color: #f8f8f8;
$font-size: 13px;
.reportList {
  .reportList-nav {
    height: auto;
    background: #f8f8f8;
    padding: 10px;
    .el-form-item {
      margin-bottom: 10px;
    }
    // .el-checkbox-button, .el-checkbox-button__inner{
    //   margin-right: 10px;
    // }
  }
  .reportList-table {
    border-top: 2px solid #dddddd;
    background: #f3f5f9;
    padding-bottom: 40px;
  }
  .reportList-total {
    position: fixed;
    bottom: 0;
    width: calc(100% - 140px);
    background: rgb(215, 215, 215);
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }
}
</style>
